import { render } from "./FamilyForm.vue?vue&type=template&id=128f7e7b"
import script from "./FamilyForm.vue?vue&type=script&lang=js"
export * from "./FamilyForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__